import type { RAGStatus } from '@/components/machines/RAGBadge';

export interface SlotRagResult {
  status: RAGStatus;
  percentageFilled: number;
}

export interface RagThresholds {
  greenThreshold: number;
  amberThreshold: number;
}

/** Mirrors services/rag.service.ts calculateSlotRAG for client-side slot display. */
export function calculateSlotRagStatus(
  currentQuantity: number,
  maxCapacity: number,
  thresholds: RagThresholds = { greenThreshold: 80, amberThreshold: 60 }
): SlotRagResult {
  if (maxCapacity <= 0) {
    return { status: 'GREEN', percentageFilled: 100 };
  }

  const percentageFilled = (currentQuantity / maxCapacity) * 100;

  let status: RAGStatus;
  if (percentageFilled >= thresholds.greenThreshold) {
    status = 'GREEN';
  } else if (percentageFilled >= thresholds.amberThreshold) {
    status = 'AMBER';
  } else {
    status = 'RED';
  }

  return {
    status,
    percentageFilled: Math.round(percentageFilled * 100) / 100,
  };
}
